/**
* Created by tudou on 2020/4/27 19:59.
*/
<template>
  <div>
    <h1>todoList</h1>
  </div>
</template>

<script>
export default {
  name: 'TodoList',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>

</style>
